import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef } from 'react';
import { useUuid, mergeRefs } from '@mantine/hooks';
import { AccordionItem } from './AccordionItem/AccordionItem.js';
import { useAccordionState } from './use-accordion-state/use-accordion-state.js';
import { useAccordionFocus } from './use-accordion-focus/use-accordion-focus.js';
import { filterChildrenByType } from '../../utils/filter-children-by-type/filter-children-by-type.js';
import { Box } from '../Box/Box.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var Accordion = forwardRef(function (_a, ref) {
  var _b = _a,
      children = _b.children,
      _b$initialItem = _b.initialItem,
      initialItem = _b$initialItem === void 0 ? -1 : _b$initialItem,
      initialState = _b.initialState,
      state = _b.state,
      onChange = _b.onChange,
      _b$multiple = _b.multiple,
      multiple = _b$multiple === void 0 ? false : _b$multiple,
      _b$disableIconRotatio = _b.disableIconRotation,
      disableIconRotation = _b$disableIconRotatio === void 0 ? false : _b$disableIconRotatio,
      _b$transitionDuration = _b.transitionDuration,
      transitionDuration = _b$transitionDuration === void 0 ? 200 : _b$transitionDuration,
      _b$iconPosition = _b.iconPosition,
      iconPosition = _b$iconPosition === void 0 ? "left" : _b$iconPosition,
      _b$offsetIcon = _b.offsetIcon,
      offsetIcon = _b$offsetIcon === void 0 ? true : _b$offsetIcon,
      _b$iconSize = _b.iconSize,
      iconSize = _b$iconSize === void 0 ? 24 : _b$iconSize,
      _b$order = _b.order,
      order = _b$order === void 0 ? 3 : _b$order,
      icon = _b.icon,
      classNames = _b.classNames,
      styles = _b.styles,
      id = _b.id,
      others = __objRest(_b, ["children", "initialItem", "initialState", "state", "onChange", "multiple", "disableIconRotation", "transitionDuration", "iconPosition", "offsetIcon", "iconSize", "order", "icon", "classNames", "styles", "id"]);

  var uuid = useUuid(id);
  var items = filterChildrenByType(children, AccordionItem);

  var _useAccordionFocus = useAccordionFocus(items.length),
      handleItemKeydown = _useAccordionFocus.handleItemKeydown,
      assignControlRef = _useAccordionFocus.assignControlRef;

  var _useAccordionState = useAccordionState({
    multiple: multiple,
    total: items.length,
    initialItem: initialItem,
    state: state,
    initialState: initialState,
    onChange: onChange
  }),
      _useAccordionState2 = _slicedToArray(_useAccordionState, 2),
      value = _useAccordionState2[0],
      handlers = _useAccordionState2[1];

  var controls = items.map(function (item, index) {
    var _a2, _b2, _c;

    return /* @__PURE__ */React.createElement(AccordionItem, __spreadProps(__spreadValues({}, item.props), {
      icon: item.props.icon || icon,
      iconPosition: item.props.iconPosition || iconPosition,
      disableIconRotation: disableIconRotation,
      key: index,
      transitionDuration: transitionDuration,
      opened: value[index],
      onToggle: function onToggle() {
        return handlers.toggle(index);
      },
      classNames: ((_a2 = item.props) == null ? void 0 : _a2.classNames) || classNames,
      styles: ((_b2 = item.props) == null ? void 0 : _b2.styles) || styles,
      id: "".concat(uuid, "-").concat(index),
      onControlKeyDown: handleItemKeydown(index),
      controlRef: mergeRefs(assignControlRef(index), (_c = item.props) == null ? void 0 : _c.controlRef),
      offsetIcon: offsetIcon,
      iconSize: iconSize,
      order: order
    }));
  });
  return /* @__PURE__ */React.createElement(Box, __spreadValues({
    ref: ref
  }, others), controls);
});
Accordion.Item = AccordionItem;
Accordion.displayName = "@mantine/core/Accordion";
export { Accordion };